import { getBackVersion } from '../config';
import { AccountSetupAnswerSnapshot } from '../models/Account/AccountSetupAnswer';
import api from './api';

const getSetup = (): Promise<AccountSetupAnswerSnapshot[]> => {
    return api.request<AccountSetupAnswerSnapshot[]>({
        method: 'GET',
        url: `${getBackVersion()}/account/setup`,
    });
};

const updateSetupAnswer = (
    question: string,
    answer: string
): Promise<AccountSetupAnswerSnapshot> => {
    return api.request<AccountSetupAnswerSnapshot>({
        method: 'POST',
        url: `${getBackVersion()}/account/setup`,
        data: {
            question,
            answer,
        },
    });
};

export default {
    getSetup,
    updateSetupAnswer,
};
